<template>
  <div class="app-modal-dialog--driver-cleanup app-modal-dialog">
    <div class="app-modal-dialog__content">
      <div :key="driver.name" class="app-modal-dialog__header">
        <h2 class="app-modal-dialog__title">
        <span 
          class="app-modal-dialog__subtitle"
          ref="name"
          v-html="sanitize(driver.name)"
          title="Driver Name"
        ></span>
        Driver Version Clean Up</h2>
      </div>
      <div class="app-modal-dialog__body">
        <p>The version(s) listed are not being used in any projects and will be deleted. Select Confirm to delete.</p>
        <slot></slot>
        <div v-if="processing">
          <app-loader class="is--inline" />
        </div>
        <div class="">
          <slot></slot>
          <div v-if="driver.id"
            class="element-table__wrapper">
            <table v-if="versions.length">
              <thead>
                <tr>
                  <th>Version ID</th>
                  <th>Description</th>
                  <th>Created Date</th>
                  <th>Uploaded By</th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                <driver-dashboard-version-item
                    v-for="version in sortedVersions(versions)"
                    :key="`version-${version.id}`"
                    :version="version">
                </driver-dashboard-version-item>
              </tbody>
            </table>
            <div v-else="versions.length == 0" class="app-asset-manager__preview-body-empty element-empty-instructions">
                <img class="app-asset-manager__preview-body-empty-img" src="/img/undraw_select_option_re_u4qn.svg" />
                <p>No versions currently unused.</p>
            </div>
          </div>
        </div>
        <div class="app-modal-dialog__footer" v-if="!processing">
          <app-button
            theme="secondary"
            @click="cancel">
            Cancel
          </app-button>
          <app-button
            v-if="versions.length > 0"
            theme="primary"
            @click="confirmCleanup">
            Confirm
          </app-button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import DOMPurify from 'dompurify'
import api from '../api/drivers'
import DriverDashboardVersionItem from './DriverDashboardVersionItem'

export default {
  components: { DriverDashboardVersionItem },
  props: {
    driver: {
      type: Object,
      default: () => ({})
    }
  },
  data () {
    return {
      versions: null,
      processing: false,
      redirectUrl: '/admin/drivers'
    }
  },
  beforeMount () {
    this.versions = this.driver.versions?.length ? this.driver.versions : []
  },
  methods: {
    sortedVersions (versions) {
      return [...versions].sort((a, b) => new Date(b.updated_at) - new Date(a.updated_at))
    },
    async confirmCleanup () {
      this.processing = true
      await api.deleteAllUnUsedDrivers(this.driver.id)
        .then((data) => {
          this.processing = false
          if (data?.success) {
            sessionStorage.setItem('flash_success', 'Selected driver versions have been deleted successfully.')
          }
        })
        .catch((err) => {
          this.processing = false
        })
      location = this.redirectUrl
    },
    cancel () {
      location = this.redirectUrl
    },
    sanitize (html) {
      return DOMPurify.sanitize(html || '')
    }
  }
}
</script>